import { findCompatibleMonitorArms } from './ulti-content-finder-core.js';
import { catalog, bestSellers, aliases } from './ulti-content-catalog-data.js';

const nativeHeavyView = 'ulti-monitor-heavy';
const filterUrl = new URL(location.href);
// Legacy filter links keep working; the native view carries server state.
if (filterUrl.pathname === '/pages/monitor-arms' && filterUrl.searchParams.get('heavyDuty') === '1' && filterUrl.searchParams.get('view') !== nativeHeavyView) {
  filterUrl.searchParams.set('view', nativeHeavyView);
  location.replace(filterUrl.href);
} else {
  initialize();
}

function initialize(root = document) {
  root.querySelectorAll('[data-content-finder]:not([data-ready])').forEach(finder => {
    finder.dataset.ready = 'true';
    const field = name => finder.querySelector(`[name="${name}"]`);
    const update = () => {
      const answers = { configuration: field('configuration').value, size: field('size').value, weight: field('weight').value, vesa: field('vesa').value, mounting: field('mounting').value, display: field('curved').checked ? 'curved' : 'standard' };
      const valid = ['size', 'weight'].every(name => !field(name).value || (field(name).validity.valid && Number(field(name).value) > 0));
      const matches = valid ? findCompatibleMonitorArms(answers).slice(0, 2) : [];
      const output = finder.querySelector('[data-finder-results]');
      output.replaceChildren();
      matches.forEach((arm, index) => {
        const card = finder.querySelector('[data-finder-card]').content.cloneNode(true);
        card.querySelector('h3').textContent = arm.name;
        card.querySelector('[data-finder-reason]').textContent = arm.whyThisProduct;
        card.querySelector('[data-finder-rank]').textContent = index === 0 ? finder.dataset.recommended : finder.dataset.alternative;
        card.querySelector('a').href = `/products/${encodeURIComponent(arm.handle)}`;
        output.append(card);
      });
      if (!matches.length) output.append(finder.querySelector('[data-finder-empty]').content.cloneNode(true));
    };
    finder.addEventListener('input', update);
    finder.addEventListener('change', update);
    update();
  });
  root.querySelectorAll('[data-content-catalog]:not([data-ready])').forEach(section => {
    section.dataset.ready = 'true';
    const cards = [...section.querySelectorAll('[data-product-handle]')];
    const controls = section.querySelector('[data-catalog-controls]');
    const target = section.querySelector('[data-catalog-grid]');
    const select = name => section.querySelector(`[name="${name}"]`);
    cards.forEach(card => {
      const data = catalog[card.dataset.productHandle] || { specs: {} };
      const specs = card.querySelector('[data-product-specs]');
      const feature = [['usb', 'USB ports'], ['lighting', 'Lighting'], ['cableManagement', 'Cable management'], ['mechanism', 'Mechanism'], ['mounting', 'Mounting']].find(([key]) => data.specs[key]);
      if (specs) for (const [key, label] of [['screenSizes', 'Screen range'], ['capacity', 'Capacity'], ...(feature ? [feature] : [])]) if (data.specs[key]) {
        const item = document.createElement('li');
        item.textContent = `${label}: ${data.specs[key]}`;
        specs.append(item);
      }
    });
    if (!controls) return;
    controls.hidden = false;
    const params = new URL(location.href).searchParams;
    const category = aliases[params.get('category')?.toLowerCase()];
    select('category').value = category || section.dataset.serverCategory || 'all';
    select('heavyDuty').checked = section.dataset.serverHeavy === 'true';
    const order = card => {
      const handle = card.dataset.productHandle, data = catalog[handle] || { specs: {} };
      const best = bestSellers.indexOf(handle);
      if (best !== -1) return best;
      if (/best.?seller|featured|popular/i.test(card.dataset.tags || '')) return 5;
      const heavy = card.dataset.heavyDuty === 'true';
      return (heavy || /heavy[\s-]?duty|ultra[\s-]?wide/i.test(card.dataset.title)) ? 30 : card.dataset.category === 'single-arm' ? 10 : card.dataset.category === 'dual-arm' ? 20 : card.dataset.category === 'triple-arm' ? 40 : 50;
    };
    const hasActiveFilter = () => select('category').value !== 'all' || select('availability').value !== 'all' || select('price').value !== 'all' || select('heavyDuty').checked;
    const update = () => {
      const sort = select('sort').value;
      const sorted = [...cards].sort((a, b) => sort === 'price-asc' ? Number(a.dataset.price) - Number(b.dataset.price) : sort === 'price-desc' ? Number(b.dataset.price) - Number(a.dataset.price) : sort === 'title-asc' ? a.dataset.title.localeCompare(b.dataset.title) : order(a) - order(b) || a.dataset.title.localeCompare(b.dataset.title));
      let count = 0;
      target.querySelectorAll('[data-catalog-group]').forEach(node => node.remove());
      const grouped = sort === 'featured' && !hasActiveFilter();
      let previousGroup;
      sorted.forEach(card => {
        const data = catalog[card.dataset.productHandle] || { specs: {} }, price = Number(card.dataset.price) / 100;
        const category = select('category').value, band = select('price').value;
        const matches = (category === 'all' || card.dataset.category === category) && (select('availability').value !== 'in-stock' || card.dataset.available === 'true') && (!select('heavyDuty').checked || card.dataset.heavyDuty === 'true') && (band === 'all' || (band === 'under-100' ? price < 100 : band === '100-200' ? price >= 100 && price <= 200 : price > 200));
        card.hidden = !matches;
        if (matches) count++;
        if (matches && grouped) {
          const rank = order(card);
          const group = rank < 10 ? 'Best Sellers' : rank < 20 ? 'Single Monitor Arms' : rank < 30 ? 'Dual Monitor Arms' : rank < 40 ? 'Heavy Duty / Ultrawide' : rank < 50 ? 'Triple / Stackable' : 'Other Display Mounting Solutions';
          if (group !== previousGroup) {
            const heading = document.createElement('h3');
            heading.dataset.catalogGroup = '';
            heading.textContent = group;
            target.append(heading);
            previousGroup = group;
          }
        }
        target.append(card);
      });
      section.querySelector('[data-catalog-count]').textContent = `${count}`;
      const schema = document.getElementById(section.dataset.schemaId);
      if (schema) {
        const data = JSON.parse(schema.textContent);
        data.numberOfItems = count;
        data.itemListElement = sorted.filter(card => !card.hidden).map((card, index) => ({ '@type': 'ListItem', position: index + 1, name: card.dataset.title, url: card.querySelector('h3 a').href }));
        schema.textContent = JSON.stringify(data);
      }
      const empty = section.querySelector('[data-catalog-empty]');
      if (empty) {
        const showEmptyState = count === 0 && (hasActiveFilter() || cards.length === 0);
        empty.textContent = showEmptyState ? empty.dataset.emptyLabel || 'No products match these filters.' : '';
        empty.hidden = !showEmptyState;
      }
    };
    controls.addEventListener('change', event => {
      if (event.target.name === 'heavyDuty') {
        const url = new URL(location.href);
        if (select('category').value === 'all') url.searchParams.delete('category');
        else url.searchParams.set('category', select('category').value);
        if (select('heavyDuty').checked) { url.searchParams.set('heavyDuty', '1'); url.searchParams.set('view', nativeHeavyView); }
        else { url.searchParams.delete('heavyDuty'); if (url.searchParams.get('view') === nativeHeavyView) url.searchParams.delete('view'); }
        location.assign(url.href);
        return;
      }
      if (event.target.name === 'category') {
        const url = new URL(location.href);
        if (select('category').value === 'all') url.searchParams.delete('category');
        else url.searchParams.set('category', select('category').value);
        history.replaceState({}, '', url);
      }
      update();
    });
    controls.addEventListener('click', event => {
      if (!event.target.closest('[data-clear-filters]')) return;
      for (const field of controls.querySelectorAll('select')) field.selectedIndex = 0;
      select('heavyDuty').checked = false;
      const resetUrl = new URL(location.href);
      resetUrl.searchParams.delete('category');
      resetUrl.searchParams.delete('heavyDuty');
      if (resetUrl.searchParams.get('view') === nativeHeavyView) resetUrl.searchParams.delete('view');
      if (section.dataset.serverFiltered === 'true') { location.assign(resetUrl.href); return; }
      history.replaceState({}, '', resetUrl);
      update();
    });
    update();
  });
}
document.addEventListener('shopify:section:load', () => initialize());

